(function () {
	const header = () => {
		const body = document.querySelector("body");
		const header = document.querySelector(".shopify-section-header");
		const headerDetails = document.querySelector(".menu-drawer-container");
		const headerIsAlwaysSticky =
			header
				.querySelector(".header-wrapper")
				.getAttribute("data-sticky-type") === "always";

		headerDetails.addEventListener("toggle", function (e) {
			const colorScheme =
				this.querySelector("#menu-drawer").dataset.colorScheme;
			header.classList.toggle(colorScheme);
		});

		document.addEventListener("keyup", (e) => {
			if (e.key === "Escape") {
				header.classList.remove("shopify-section-header-sticky", "animate");
				body.classList.remove("overflow-hidden");
			}
		});

		document.addEventListener("scroll", () => {
			let scrollTop = window.scrollY;
			if (scrollTop > header.offsetHeight && headerIsAlwaysSticky) {
				header.classList.add("fixed", "animate");
			} else if (scrollTop <= header.offsetHeight && headerIsAlwaysSticky) {
				header.classList.remove("fixed", "animate");
			}
		});

		//$(".mega-menu-details summary").click(function (e) {
		//	e.preventDefault();
		//	const attrOpen = $(this).attr("open");
		//	if (attrOpen === false || attrOpen === undefined) {
		//		console.log(attrOpen);
		//		//$(".mega-menu-details").removeAttr("open");
		//		//$(this).attr("open", "open");
		//	} else {
		//		$(".mega-menu-details").removeAttr("open");
		//	}
		//});

		$(".header__icon--account").click(function (e) {
			$(".search-modal").removeClass("active");
		});

		const announcementBar = document.querySelector(".announcement-bar");
		const headerOffcanvas = document.querySelector(".burger-drawer");
		const headerOverlayWithBackground = document.querySelector('[data-overlay-with-background]')?.dataset.overlayWithBackground === 'true';

		announcementBar &&
			headerOffcanvas &&
			headerOffcanvas.classList.add("announcement-bar-show");

		/* Announcement bar always visible - no hide on scroll */
		/* Header stays transparent - no background on hover */
	};
	document.addEventListener("shopify:section:load", header);
	header();
})();

/* Adaptive header text colour (transparent header, contrast-aware).
 * The header is intentionally transparent on every scroll position. To keep
 * the menu/search/cart labels readable, this module measures the brightness
 * of whatever section sits directly behind the header and flips the text
 * between dark (#060606) over light sections and white over dark/media
 * sections. Pure additive logic - it does not change the transparent look. */
(function () {
	var STYLE_ID = "hdr-adaptive-color-style";

	function injectStyle() {
		if (document.getElementById(STYLE_ID)) return;
		var light = "html[data-scheme] .shopify-section-header.hdr-on-light.hdr-on-light.hdr-on-light .header .header-top ";
		var dark = "html[data-scheme] .shopify-section-header.hdr-on-dark.hdr-on-dark.hdr-on-dark .header .header-top ";
		var targets = [
			".header-top__wrapper a",
			".header-top__wrapper button",
			".header-top__wrapper svg",
			".header__heading-link",
			".header__icon",
			".header__scheme",
			".header-top__right *"
		];
		function rule(prefix, color) {
			return targets
				.map(function (t) { return prefix + t; })
				.join(",") + "{color:" + color + " !important;fill:" + color + " !important;}";
		}
		var css = rule(light, "#060606") + rule(dark, "#ffffff");
		var s = document.createElement("style");
		s.id = STYLE_ID;
		s.appendChild(document.createTextNode(css));
		(document.head || document.documentElement).appendChild(s);
	}

	function bgLuminance(node) {
		while (node && node !== document.documentElement) {
			var cs = window.getComputedStyle(node);
			var bg = cs.backgroundColor;
			var m = bg && bg.match(/rgba?\(\s*([\d.]+)[ ,]+([\d.]+)[ ,]+([\d.]+)(?:[ ,/]+([\d.]+))?/i);
			if (m) {
				var a = m[4] === undefined ? 1 : parseFloat(m[4]);
				if (a >= 0.5) {
					return (0.2126 * +m[1] + 0.7152 * +m[2] + 0.0722 * +m[3]) / 255;
				}
			}
			node = node.parentElement;
		}
		return null;
	}

	var MEDIA_RE = /(slideshow|hero|image-banner|video-banner|collage|lookbook|parallax|showcase|grid-banner|split_screen)/i;

	function update() {
		var header = document.querySelector(".shopify-section-header");
		if (!header) return;
		injectStyle();
		var rect = header.getBoundingClientRect();
		var y = Math.max(1, Math.min(rect.bottom - 2, window.innerHeight - 2));
		var x = Math.round(window.innerWidth / 2);
		var stack = (document.elementsFromPoint(x, y) || []).filter(function (el) {
			return el && el !== header && !header.contains(el);
		});
		var target = stack[0];
		if (!target) return;
		var section = target.closest ? target.closest(".shopify-section") : null;
		var onLight;
		if (section && MEDIA_RE.test(section.className || "") && section.querySelector("img, video, .placeholder-svg")) {
			onLight = false; /* media heroes carry a dark overlay + white text */
		} else {
			var lum = bgLuminance(target);
			onLight = lum === null ? true : lum >= 0.6;
		}
		header.classList.toggle("hdr-on-light", onLight);
		header.classList.toggle("hdr-on-dark", !onLight);
	}

	var ticking = false;
	function onScroll() {
		if (ticking) return;
		ticking = true;
		window.requestAnimationFrame(function () { update(); ticking = false; });
	}

	function init() {
		update();
		window.addEventListener("scroll", onScroll, { passive: true });
		window.addEventListener("resize", onScroll, { passive: true });
		setTimeout(update, 300);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
	document.addEventListener("shopify:section:load", update);
})();

/* Represent product page: stacked vertical gallery.
 * On the product page (.rp-gallery present) this rebuilds the media gallery
 * into a vertically stacked column of full images with a vertical thumbnail
 * rail that jumps to each image; the info/buy column becomes sticky. You
 * scroll through every image, then the page flows on to the next section.
 * It clears the old single-image + bottom-thumb markup, so the original
 * product-page-represent.js gallery code finds nothing and safely no-ops. */
(function () {
	var CSS_ID = "rp-stacked-gallery-style";

	function injectStyle() {
		if (document.getElementById(CSS_ID)) return;
		var css =
			".rp-vthumb{width:6.4rem;height:8rem;flex-shrink:0;cursor:pointer;opacity:.45;border:2px solid transparent;background:#eee;padding:0;overflow:hidden;transition:opacity .2s,border-color .2s}" +
			".rp-vthumb img{width:100%;height:100%;object-fit:cover;display:block}" +
			".rp-vthumb.active,.rp-vthumb:hover{opacity:1;border-color:#000}" +
			".rp-gallery.rp-stacked .rp-stack{display:flex;flex-direction:column;gap:.8rem;min-width:0;flex:1}" +
			".rp-gallery.rp-stacked .rp-stack__item img{width:100%;height:auto;display:block}" +
			".rp-gallery.rp-stacked .rp-vthumbs::-webkit-scrollbar{display:none}" +
			"@media (min-width:990px){" +
			".rp-product .rp-hero{align-items:flex-start}" +
			".rp-gallery.rp-stacked{position:static !important;width:60%;max-height:none !important;overflow:visible !important;display:flex;gap:1rem;align-items:flex-start}" +
			".rp-gallery.rp-stacked .rp-vthumbs{position:sticky;top:calc(var(--header-height,80px) + 1.5rem);display:flex;flex-direction:column;gap:.6rem;width:6.4rem;flex-shrink:0;max-height:calc(100vh - var(--header-height,80px) - 3rem);overflow-y:auto;scrollbar-width:none}" +
			".rp-product .rp-info{position:sticky;top:calc(var(--header-height,80px) + 1.5rem);align-self:flex-start}" +
			"}" +
			"@media (max-width:989px){" +
			".rp-gallery.rp-stacked{display:block}" +
			".rp-gallery.rp-stacked .rp-vthumbs{display:flex;flex-direction:row;gap:.4rem;overflow-x:auto;padding:.6rem 0;scrollbar-width:none}" +
			"}";
		var s = document.createElement("style");
		s.id = CSS_ID;
		s.appendChild(document.createTextNode(css));
		(document.head || document.documentElement).appendChild(s);
	}

	function headerOffset() {
		var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--header-height"));
		return (isNaN(v) ? 80 : v) + 24;
	}

	/* Bring a thumb into view inside the rail's OWN scroll box, nothing else.
	 * scrollIntoView() scrolls every scrollable ancestor including the page.
	 * On mobile the rail is a static row sitting above the images (it is only
	 * sticky from 990px up), so once you scrolled past it, highlighting the
	 * next thumb dragged the page back up to the rail - the media column could
	 * not be scrolled through at all. Nudging scrollLeft/scrollTop keeps the
	 * page scroll untouched and leaves desktop behaviour identical. */
	function revealInRail(rail, btn) {
		if (!rail || !btn) return;
		var r = rail.getBoundingClientRect();
		var b = btn.getBoundingClientRect();
		if (rail.scrollWidth > rail.clientWidth + 1) {
			rail.scrollLeft += (b.left + b.width / 2) - (r.left + r.width / 2);
		}
		if (rail.scrollHeight > rail.clientHeight + 1) {
			if (b.top < r.top) rail.scrollTop += b.top - r.top;
			else if (b.bottom > r.bottom) rail.scrollTop += b.bottom - r.bottom;
		}
	}

	function build() {
		var gallery = document.querySelector(".rp-gallery");
		if (!gallery || gallery.getAttribute("data-rp-stacked") === "1") return;
		var thumbs = gallery.querySelectorAll(".rp-gallery__thumb");
		if (!thumbs.length) return;

		var items = [];
		thumbs.forEach(function (t) {
			var im = t.querySelector("img");
			items.push({
				full: t.getAttribute("data-full-src") || (im ? im.src : ""),
				thumb: im ? im.getAttribute("src") : "",
				alt: im ? (im.getAttribute("alt") || "") : ""
			});
		});

		var vthumbs = document.createElement("div");
		vthumbs.className = "rp-vthumbs";
		var stack = document.createElement("div");
		stack.className = "rp-stack";

		items.forEach(function (it, i) {
			var b = document.createElement("button");
			b.type = "button";
			b.className = "rp-vthumb" + (i === 0 ? " active" : "");
			b.setAttribute("data-i", i);
			var ti = document.createElement("img");
			ti.src = it.thumb || it.full;
			ti.alt = it.alt;
			ti.loading = "lazy";
			b.appendChild(ti);
			vthumbs.appendChild(b);

			var d = document.createElement("div");
			d.className = "rp-stack__item";
			d.setAttribute("data-i", i);
			var fi = document.createElement("img");
			fi.src = it.full;
			fi.alt = it.alt;
			fi.loading = i === 0 ? "eager" : "lazy";
			d.appendChild(fi);
			stack.appendChild(d);
		});

		gallery.innerHTML = "";
		if (items.length > 1) gallery.appendChild(vthumbs);
		gallery.appendChild(stack);
		gallery.classList.add("rp-stacked");
		gallery.setAttribute("data-rp-stacked", "1");
		injectStyle();

		var vbtns = vthumbs.querySelectorAll(".rp-vthumb");
		var sitems = stack.querySelectorAll(".rp-stack__item");

		vbtns.forEach(function (b) {
			b.addEventListener("click", function () {
				var i = parseInt(b.getAttribute("data-i"), 10);
				var target = sitems[i];
				if (!target) return;
				var y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
				window.scrollTo({ top: y, behavior: "smooth" });
			});
		});

		if ("IntersectionObserver" in window && sitems.length) {
			var obs = new IntersectionObserver(function (entries) {
				entries.forEach(function (e) {
					if (!e.isIntersecting) return;
					var i = parseInt(e.target.getAttribute("data-i"), 10);
					vbtns.forEach(function (x) { x.classList.remove("active"); });
					if (vbtns[i]) {
						vbtns[i].classList.add("active");
						revealInRail(vthumbs, vbtns[i]);
					}
				});
			}, { rootMargin: "-45% 0px -45% 0px", threshold: 0 });
			sitems.forEach(function (s) { obs.observe(s); });
		}
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", build);
	} else {
		build();
	}
	document.addEventListener("shopify:section:load", build);
})();
